export enum SortOrder {
  Asc = 1,
  Des = -1,
}

export interface SortEvent {
  by: string;
  order: SortOrder;
}
